import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ProductionModule } from '../rcs/production-module/production.module';
import { AdminModule } from './admin-module/admin.module';
import { NgxPermissionsModule } from 'ngx-permissions';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ProductionModule,
    AdminModule,
    NgxPermissionsModule.forRoot(),
    RouterModule.forChild([
      {
        path: 'production', loadChildren: () => import('../rcs/production-module/production.module').then(m => m.ProductionModule),
      },
      {
        path: 'admin', loadChildren: () => import('../rcs/admin-module/admin.module').then(m => m.AdminModule),
      },
    ]),
  ],
})
export class RcsModule { }
